/**
 * /cli/device の日本語（en.cliDevice.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 */
import type { enCliDevice } from './en.cliDevice';

type CliDeviceMessages = { [K in keyof typeof enCliDevice]: string };

export const jaCliDevice: CliDeviceMessages = {
  'cliDevice.title': 'このコードでログインしますか？',
  'cliDevice.lead': 'このコードが、チャットかターミナルに出ているものと同じか確かめてください。同じなら「許可」を押してください。',
  'cliDevice.device': '端末（自分で名乗った名前）: {device}',
  'cliDevice.allow': '許可',
  'cliDevice.unverifiedThen': 'メールの確認が済んだら、このページを再読み込みしてください。',
  'cliDevice.allowedTitle': '完了しました',
  'cliDevice.allowedBody': 'ログインしました。このタブを閉じて、チャットかターミナルに戻ってください。',
  'cliDevice.cancelledTitle': 'やめました',
  'cliDevice.cancelledBody': 'ログインはしていません。このタブを閉じて、チャットかターミナルに戻ってください。',
  'cliDevice.invalidTitle': 'このリンクは使えません',
  'cliDevice.invalidBody': 'リンクのコードが無いか、途中で切れています。チャットかターミナルでもう一度ログインを始めると、新しいリンクが出ます。',
  'cliDevice.notFoundTitle': 'このコードは見つかりません',
  'cliDevice.notFoundBody': 'リンクを最後まで開いたか確かめてください。それでもだめなら、チャットかターミナルでもう一度ログインを始めてください。',
  'cliDevice.expiredTitle': 'このコードは期限が切れました',
  'cliDevice.expiredBody': 'コードが使えるのは 10 分です。チャットかターミナルでもう一度ログインを始めると、新しいコードが出ます。',
  'cliDevice.usedTitle': 'このコードはもう使われました',
  'cliDevice.usedBody': 'コードは 1 回だけ使えます。まだログインが要るなら、チャットかターミナルでもう一度始めてください。'
};
